export default () => {

  if ($('.find-community-filters').length) {

    $('html').on('click', '.find-community-filters-mobile-toggle', (e) => {
      e.preventDefault();
      $(e.currentTarget).attr('data-open', $(e.currentTarget).attr('data-open') === 'true' ? 'false' : 'true');
      $(e.currentTarget).trigger('blur').next().stop(true, true)
        .animate({
          height: 'toggle',
          opacity: 'toggle'
        }, 300)
      ;
    });

  }

};
